document.addEventListener('DOMContentLoaded', () => {
    const swipers = document.querySelectorAll('.articleCard-carousel .swiper')

    // Adding unique identifiers to each Swiper
    swipers.forEach((swiperElement, index) => {
        swiperElement.setAttribute('data-swiper-id', `article-swiper-${index}`)
    })

    // Function to initialize Swiper
    const initiateSlider = swiperElement => {
        const identifier = `.swiper[data-swiper-id="${swiperElement.dataset.swiperId}"]` 

        const mainConfigs = {
            slidesPerView: "auto",
            direction: 'horizontal',
            spaceBetween: 16,
            loop: false,
            
            pagination: {
                el: `${identifier} .swiper-pagination-fraction`,
                type: "fraction",
            },
            
            navigation: {
                nextEl: `${identifier} .swiper-button-next`,
                prevEl: `${identifier} .swiper-button-prev`,
            },
        }

        const progressConfigs = {
            slidesPerView: "auto",
            direction: 'horizontal',
            spaceBetween: 16,
            loop: false,
            
            pagination: {
              el: `${identifier} .swiper-pagination-progress`,
              type: "progressbar"
            },
        }

        return [new Swiper(identifier, mainConfigs), new Swiper(identifier, progressConfigs)]
    }
    
    // Initializing swipers
    swipers.forEach(swiperElement => {
        const [mainSlider, progressSlider] = initiateSlider(swiperElement)

        mainSlider.controller.control = progressSlider
    }) 
})